import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "sourceMode",
    "quoteMode",
    "sourceWrap",
    "quoteWrap",
    "sourceField",
    "quoteField",
    "summaryReceive",
    "summaryPay",
    "summaryTotal",
    "summaryAfter",
    "summaryMode",
    "summaryStatus"
  ];

  static values = {
    sourceCoin: String,
    quoteCoin: String,
    rate: Number,
    pinballFee: Number,
    networkFee: Number,
    bridgeQuantity: Number
  };

  connect() {
    this.toggle();
  }

  toggle() {
    const sourceMode = this.sourceSelected;

    if (this.hasSourceWrapTarget) {
      this.sourceWrapTarget.hidden = !sourceMode;
    }

    if (this.hasQuoteWrapTarget) {
      this.quoteWrapTarget.hidden = sourceMode;
    }

    if (sourceMode && this.hasQuoteFieldTarget) {
      this.quoteFieldTarget.value = "";
    }

    if (!sourceMode && this.hasSourceFieldTarget) {
      this.sourceFieldTarget.value = "";
    }

    this.render();
  }

  render() {
    const sourceMode = this.sourceSelected;
    const sourceCoin = this.sourceCoinValue || "COIN";
    const quoteCoin = this.quoteCoinValue || "QUOTE";

    let receiveAmount = 0;
    let payAmount = 0;

    if (sourceMode) {
      receiveAmount = this.numberValue(this.sourceFieldTarget);
      payAmount = receiveAmount * this.rateValue;
      this.writeText("summaryMode", `receive ${sourceCoin}`);
    } else {
      payAmount = this.numberValue(this.quoteFieldTarget);
      receiveAmount = this.rateValue > 0 ? payAmount / this.rateValue : 0;
      this.writeText("summaryMode", `spend ${quoteCoin}`);
    }

    const totalDue = payAmount + this.pinballFeeValue + this.networkFeeValue;
    const remaining = this.bridgeQuantityValue - receiveAmount;

    this.writeText("summaryReceive", `${this.format(receiveAmount)} ${sourceCoin}`);
    this.writeText("summaryPay", `${this.format(payAmount)} ${quoteCoin}`);
    this.writeText("summaryTotal", `${this.format(totalDue)} ${quoteCoin}`);
    this.writeText("summaryAfter", `${this.format(remaining)} ${sourceCoin}`);

    let status = `The first leg is your ${quoteCoin} send. The second leg is the bridge paying out ${sourceCoin}.`;
    if (!receiveAmount && !payAmount) {
      status = `Choose a side of the trade ticket. Enter either the ${sourceCoin} you want back or the ${quoteCoin} you want to spend.`;
    } else if (remaining < 0) {
      status = `That fill is larger than the storefront inventory by ${this.format(Math.abs(remaining))} ${sourceCoin}.`;
    } else {
      status = `This ticket asks your wallet for ${this.format(totalDue)} ${quoteCoin} including the quote-lane toll.`;
    }

    this.writeText("summaryStatus", status);
  }

  get sourceSelected() {
    return !this.hasQuoteModeTarget || !this.quoteModeTarget.checked;
  }

  writeText(targetName, text) {
    const target = this[`${targetName}Target`];
    if (target) target.textContent = text;
  }

  numberValue(target) {
    if (!target) return 0;
    const value = parseFloat(target.value);
    return Number.isFinite(value) ? value : 0;
  }

  format(value, precision = 8) {
    const numeric = Number.isFinite(value) ? value : 0;
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: precision
    }).format(numeric);
  }
}
